import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getPolicyContextConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'renters/contexts/policy_context',
    method: NetworkRequestConfiguration.Methods.GET,
  });
}
